"use strict";

/**
TODO: load these:
        <link rel="stylesheet" href="https://cdn.plyr.io/3.7.3/plyr.css" />
        <script src="https://cdn.plyr.io/3.7.3/plyr.polyfilled.js"></script>

TODO: load module only if /pages/reference-charts?

test, add scroll to reveal.
**/

AquaTechTheme.registerModule('knowledge-center', null, function() {
  AquaTechTheme.KnowledgeCenter = {
    $: null,
    wDPlayer: null,
    $plyrVid: null,
    EMBED_AFTER: '#shopify-section-template--28930268332402__template_product_info_columns_static_DCrEDK', // Insert video in new section after this (AU)

    onDocReady: function() {
      var self = this;
      self.$ = AquaTechTheme.$;

      var $embedAfter = $(self.EMBED_AFTER);
      if (!$embedAfter.length) {
        return;
      }

      self.$plyr = $('<div id="kc_player"></div>');
      $embedAfter.after(self.$plyr);

      var $view = $("button.doc-media-view");
      $view.on('click', function(e) {
        e.preventDefault();

        var $select = $(this).parent().find('select');
        var selection = $select.val();
        if (selection) {
            self.loadSelection(selection);
        }
      });
    },

    loadSelection: function(url) {
      var self = this;
      $ = self.$;

      console.log('loadSelection ' + url);

      if (url.indexOf('youtu') !== -1) {
        var videoProps = self.parseYTUrl(url);
        self.$plyr.html('');
        var $plyrVid = $('<section><div class="wrapper-padded plyr__video-embed"><div id="kc_player_vid" data-plyr-provider="youtube" data-plyr-embed-id="' + videoProps.id + '" style="width: 560px; height: 315px;"></div></div></section>');

        self.$plyr.append($plyrVid);
        self.initPlayer(videoProps);

        $('html, body').animate({
            scrollTop: $("#kc_player").offset().top - 200
        }, 1000);
        
      } else {
        // Not YouTube:
        window.open(url, '_blank').focus();
      }
    },

    parseYTUrl: function(url) {
      var videoProps = {
        id: null,
        t: 0
      };

      url = url.replaceAll('&amp;', '&');

      if (url.indexOf('youtube.com/watch') !== -1) {
        var parts = url.split('?');
        var params = new URLSearchParams(parts[1]);
        videoProps.id = params.get('v');
        var t = params.get('t');
        videoProps.t = t ? parseInt(t) : 0;

      } else {
        videoProps.id = url.replace('https://youtu.be/', '');
      }

      return videoProps;
    },

    initPlayer: function(videoProps) {
      var wDPlayer = new Plyr('#kc_player_vid', {
        controls: ['play-large', 'play', 'progress', 'current-time' ],
        fullscreen: {
          enabled: false,
          iosNative: false
        },
        storage: {
          enabled: false
        },
        youtube: {
          noCookie: false,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          enablejsapi: 1,
          loop: 0,
          playlist: videoProps.id,
          controls: 1
        },
      });

      wDPlayer.on('ready', function() {
        if (videoProps.t !== 0) {
          wDPlayer.embed.seekTo(videoProps.t);
        }
      });
    }    
    
  };

  AquaTechTheme.$(function() { AquaTechTheme.KnowledgeCenter.onDocReady(); });
});
